<template>
  <a-result status="error" :title="title" :sub-title="message" />
</template>

<script>
export default {
  data() {
    return {
      title: "",
      message: "系统检测到您的链接无效，请联系管理员",
    };
  },
  mounted() {
    const { title, msg } = this.$route.query;
    this.title = title;
    this.message = msg;
  },
};
</script>
